import getConfig from 'next/config';
import Request from '@apester/requests';

const { publicRuntimeConfig: { config } } = getConfig();

const GENERAL_VERTICAL = 'all';

const getResponseJson = async (url) => Request.Get(new URL(url), {}, { withCredentials: true });

const fetchAllLayouts = async () => {
  const json = await getResponseJson(`${config.INTERACTION_URL}/engine`);
  const layouts = await getResponseJson(`${config.INTERACTION_URL}/engine/${json.payload[0].engineId}/layout`);

  return layouts?.payload;
};

const findLayout = (key, value, layouts) => layouts?.find((layout) => layout[key] === value);

const fetchTemplates = async (vertical?) => {
  const verticalParam = vertical && vertical !== GENERAL_VERTICAL ? `/${vertical}` : '';
  const json = await getResponseJson(`${config.INTERACTION_URL}/editor/templates${verticalParam}`);

  return json?.payload;
};

export {
  fetchTemplates,
  fetchAllLayouts,
  findLayout,
  getResponseJson,
};
